var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9L6.75 11.25L9 18L18 0L0 9ZM7.884 10.134L14.634 3.384L9 13.5L7.884 10.134Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendReply);
export default __webpack_public_path__ + "static/media/sendReply.2cf6a6dedd8738d9a20b25d6e2ca6c7e.svg";
export { ForwardRef as ReactComponent };